import { memo } from 'react';
import { LuMoon, LuSun } from 'react-icons/lu';

import { useColorMode } from './hooks/useColorMode';

const ColorModeIconComponent = () => {
  const { colorMode } = useColorMode();
  return colorMode === 'dark' ? <LuMoon /> : <LuSun />;
};

export const ColorModeIcon = memo(ColorModeIconComponent);
